import {Injectable} from '@angular/core';
import {FaqResourceApi} from "../../../shared/services/api/faq-resource.api";


@Injectable()
export class FaqService {
  constructor(private faqApi: FaqResourceApi) {
  }

  getFaqs(lang) {
    return this.faqApi.get(lang || '');
  }
}
